import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { dictionaryAPI, type Group } from '../services/api';

export default function Dashboard() {
  const [groups, setGroups] = useState<Group[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    loadGroups();
  }, []);

  const loadGroups = async () => {
    try {
      setLoading(true);
      const data = await dictionaryAPI.getGroups();
      setGroups(data);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="text-center py-8">Loading...</div>;
  }

  if (error) {
    return (
      <div className="card">
        <div className="text-center py-8">
          <div className="text-red-600 dark:text-red-400 font-semibold mb-2">Error: {error}</div>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-4">
            Make sure the backend server is running on port 8787.
          </p>
          <p className="text-xs text-gray-500 dark:text-gray-500 mt-2">
            Run: <code className="bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">npm run dev</code> in the project root
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">Dashboard</h1>
        <p className="mt-2 text-gray-600 dark:text-gray-400">Overview of data dictionary groups</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {groups.map((group) => (
          <Link
            key={group.id}
            to={`/groups/${group.group_id}`}
            className="card hover:shadow-md transition-shadow"
          >
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{group.group_name}</h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">Group ID: {group.group_id}</p>
            {group.description && (
              <p className="text-sm text-gray-600 dark:text-gray-300 mt-2">{group.description}</p>
            )}
          </Link>
        ))}
      </div>

      {groups.length === 0 && (
        <div className="card text-center py-12">
          <p className="text-gray-500 dark:text-gray-400 mb-4">No groups found</p>
          <Link to="/import" className="btn btn-primary">
            Import Data
          </Link>
        </div>
      )}
    </div>
  );
}

